import * as React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName?.find((item) => item?._id === name?._id) === undefined
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

export default function MDDropdownCheckbox({
  label,
  options = [],
  name = "",
  arrayValue = [],
  onSelectedNamesChange,
}) {
  const theme = useTheme();

  const handleChange = (event) => {
    const {
      target: { name, value },
    } = event;

    const selectedIds = typeof value === "string" ? value.split(",") : value;

    onSelectedNamesChange({
      name: name,
      value: selectedIds,
    });
  };

  return (
    <FormControl sx={{ my: 1 }} fullWidth size="medium">
      <InputLabel id="demo-multiple-chip-label">{label}</InputLabel>
      <Select
        labelId="demo-multiple-chip-label"
        id="demo-multiple-chip"
        multiple
        size="medium"
        name={name}
        label={label}
        value={arrayValue}
        onChange={handleChange}
        sx={{ py: 1.5 }}
        input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
        renderValue={(selected) => (
          <Box sx={{ display: "flex", my: 1, flexWrap: "wrap", gap: 0.5 }}>
            {selected?.map((item, index) => (
              <Chip key={index} label={item?.name} color="info" />
            ))}
          </Box>
        )}
        MenuProps={MenuProps}
      >
        {options?.map((name, index) => (
          <MenuItem
            key={index}
            value={name}
            style={getStyles(name, arrayValue, theme)}
          >
            {name?.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
